var React = require('react');

function Key (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M35.0883 23.7502C32.3287 23.7502 30.0726 26.0899 30.0726 29.0002C30.0726 31.9106 32.3287 34.2502 35.0883 34.2502C37.848 34.2502 40.1041 31.9106 40.1041 29.0002C40.1041 26.0899 37.848 23.7502 35.0883 23.7502ZM28.6538 28.2502C29.0113 24.8837 31.7468 22.2502 35.0883 22.2502C38.6743 22.2502 41.5624 25.2832 41.5624 29.0002C41.5624 32.7173 38.6743 35.7502 35.0883 35.7502C31.7468 35.7502 29.0113 33.1168 28.6538 29.7502H15.5555V28.2502H28.6538ZM21.3889 32.7498L15.5555 32.7502L15.5554 31.2502L21.3888 31.2498L21.3889 32.7498Z","fill":"#2E2B26","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"59","height":"59","stroke":"#C3C2C1","key":1})]);
}

Key.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = Key;

Key.default = Key;
